import ApiService from "@/common/api.service";
import { FETCH_DICTIONARY } from "./actions.type";
import { SET_DICTIONARY } from "./mutations.type";

const state = {
  dictionary: {}
};

const getters = {
  dictionary: state => state.dictionary
};

const actions = {
  [FETCH_DICTIONARY](context) {
    return ApiService.get("dictionary").then(({ data }) => {
      context.commit(SET_DICTIONARY, data);
    });
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [SET_DICTIONARY](state, data) {
    state.dictionary = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
